module.exports = __webpack_public_path__ + "static/media/vibepure-3.8d1ee874.jpg";